/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext, useState } from 'react';

import { AlertColor } from '@mui/material';

export type SnackbarState = {
  severity: AlertColor;
  content: string;
  isOpen: boolean;
  autohideDuration?: number;
};

export const initialState: SnackbarState = {
  isOpen: false,
  content: '',
  severity: 'success',
};

const useSnackbarController = () => {
  const [snackbarState, setSnackbarState] =
    useState<SnackbarState>(initialState);

  return {
    snackbarState,
    setSnackbarState,
  };
};

const SnackbarContext = createContext<ReturnType<typeof useSnackbarController>>(
  { snackbarState: initialState, setSnackbarState: () => {} }
);

export const SnackbarProvider = ({ children }) => (
  <SnackbarContext.Provider value={useSnackbarController()}>
    {children}
  </SnackbarContext.Provider>
);

export const useSnackbar = () => useContext(SnackbarContext);
